// extracted by mini-css-extract-plugin
module.exports = {"content":"VipBanner_content__r7yUv","info":"VipBanner_info__4g86j","side":"VipBanner_side__QzVbF","buttonGroup":"VipBanner_buttonGroup__OEZmy","button":"VipBanner_button__RFQ37"};